import './BaseCardLabel.64cd657a4adf58dac3c023950ddbc25b.css';
export default {"label":"_label_1yj29_1"};